import { useIntl } from "react-intl";

import { ConfirmDrawer } from "@/components/ConfirmDrawer/ConfirmDrawer";

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export function TravellerCloseConfirmDrawer({
  open,
  onClose,
  onConfirm,
}: Props) {
  const intl = useIntl();

  return (
    <ConfirmDrawer
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title={intl.formatMessage({
        defaultMessage: "Are you sure you want to leave?",
        description:
          "Title of the confirmation dialog when closing the traveller form with unsaved changes",
      })}
      description={intl.formatMessage({
        defaultMessage: "Any unsaved data will be lost",
        description:
          "Body text in the 'leave without saving?' confirmation dialog for the traveller form",
      })}
      closeLabel={intl.formatMessage({
        defaultMessage: "Back",
        description: "Button to navigate back to the previous screen",
      })}
      confirmLabel={intl.formatMessage({
        defaultMessage: "Leave without saving",
        description:
          "Button to confirm leaving and discarding unsaved changes in the traveller form",
      })}
    />
  );
}
